import SvgIcon from '@mui/material/SvgIcon';

export function PmasIconMui() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1600 1600"
        shapeRendering="crispEdges"
        style={{ maxHeight: '20px' }}
      >
        <g strokeMiterlimit="22.926">
          <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="20"
            d="m353.84 1316.94-222.89-128.69V420.56L795.67 36.78l664.72 383.78v767.54l-664.72 383.78-221.87-128.1 4.32-259.08 217.55 125.6 438.19-252.98V551.34L795.67 298.36 357.48 551.34z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
